var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.5H20.5C21.0523 11.5 21.5 11.9477 21.5 12.5V20.5H25C25.2761 20.5 25.5 20.7239 25.5 21C25.5 21.2761 25.2761 21.5 25 21.5H21.5C20.9477 21.5 20.5 21.0523 20.5 20.5V17H17C16.1716 17 15.5 17.6716 15.5 18.5V32.5H40V18.5C40 17.6716 39.3284 17 38.5 17H35V20.5C35 21.0523 34.5523 21.5 34 21.5H31C30.7239 21.5 30.5 21.2761 30.5 21C30.5 20.7239 30.7239 20.5 31 20.5H34V12.5C34 11.9477 34.4477 11.5 35 11.5H41V12.5H35V16H38.5C39.8807 16 41 17.1193 41 18.5V34.5C41 35.8807 39.8807 37 38.5 37H17C15.6193 37 14.5 35.8807 14.5 34.5V18.5C14.5 17.1193 15.6193 16 17 16H20.5V12.5H15V11.5ZM40 33.5H15.5V34.5C15.5 35.3284 16.1716 36 17 36H38.5C39.3284 36 40 35.3284 40 34.5V33.5Z",
    fill: "#2C666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 13.5V19C28.5 19.2761 28.2761 19.5 28 19.5C27.7239 19.5 27.5 19.2761 27.5 19V13.5H28.5Z",
    fill: "#2C666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13ZM14 14C15.1046 14 16 13.1046 16 12C16 10.8954 15.1046 10 14 10C12.8954 10 12 10.8954 12 12C12 13.1046 12.8954 14 14 14Z",
    fill: "#2C666E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 13C42.5523 13 43 12.5523 43 12C43 11.4477 42.5523 11 42 11C41.4477 11 41 11.4477 41 12C41 12.5523 41.4477 13 42 13ZM42 14C43.1046 14 44 13.1046 44 12C44 10.8954 43.1046 10 42 10C40.8954 10 40 10.8954 40 12C40 13.1046 40.8954 14 42 14Z",
    fill: "#2C666E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 13C28.5523 13 29 12.5523 29 12C29 11.4477 28.5523 11 28 11C27.4477 11 27 11.4477 27 12C27 12.5523 27.4477 13 28 13ZM28 14C29.1046 14 30 13.1046 30 12C30 10.8954 29.1046 10 28 10C26.8954 10 26 10.8954 26 12C26 13.1046 26.8954 14 28 14Z",
    fill: "#2C666E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 21C28.2762 21 28.5001 21.2239 28.5001 21.5V23.5H27.5001V21.5C27.5001 21.2239 27.724 21 28.0001 21ZM28.5001 28.5V30.5C28.5001 30.7761 28.2762 31 28.0001 31C27.724 31 27.5001 30.7761 27.5001 30.5V28.5H28.5001Z",
    fill: "#2C666E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3302 28.5C32.1921 28.7391 31.8863 28.8211 31.6472 28.683L29.9151 27.683L30.4151 26.817L32.1472 27.817C32.3863 27.9551 32.4682 28.2609 32.3302 28.5ZM25.585 25.183L23.8529 24.183C23.6138 24.0449 23.5319 23.7391 23.6699 23.5C23.808 23.2609 24.1138 23.1789 24.3529 23.317L26.085 24.317L25.585 25.183Z",
    fill: "#2C666E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3302 23.5C32.4682 23.7391 32.3863 24.0449 32.1472 24.183L30.4151 25.183L29.9151 24.317L31.6472 23.317C31.8863 23.1789 32.1921 23.2609 32.3302 23.5ZM26.085 27.683L24.3529 28.683C24.1138 28.8211 23.808 28.7391 23.6699 28.5C23.5319 28.2609 23.6138 27.9551 23.8529 27.817L25.585 26.817L26.085 27.683Z",
    fill: "#2C666E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 28C29.1047 28 30.0001 27.1046 30.0001 26C30.0001 24.8954 29.1047 24 28.0001 24C26.8955 24 26.0001 24.8954 26.0001 26C26.0001 27.1046 26.8955 28 28.0001 28ZM28.0001 29C29.657 29 31.0001 27.6569 31.0001 26C31.0001 24.3431 29.657 23 28.0001 23C26.3432 23 25.0001 24.3431 25.0001 26C25.0001 27.6569 26.3432 29 28.0001 29Z",
    fill: "#2C666E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 36V45H27.5V36H28.5Z",
    fill: "#2C666E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 44.5C46 44.7761 45.7761 45 45.5 45H10.5C10.2239 45 10 44.7761 10 44.5C10 44.2239 10.2239 44 10.5 44H45.5C45.7761 44 46 44.2239 46 44.5Z",
    fill: "#2C666E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 17.5C46 17.7761 45.7761 18 45.5 18H43.5C43.2239 18 43 17.7761 43 17.5C43 17.2239 43.2239 17 43.5 17H45.5C45.7761 17 46 17.2239 46 17.5Z",
    fill: "#2C666E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 20.5C46 20.7761 45.7761 21 45.5 21H43.5C43.2239 21 43 20.7761 43 20.5C43 20.2239 43.2239 20 43.5 20H45.5C45.7761 20 46 20.2239 46 20.5Z",
    fill: "#2C666E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 23.5C46 23.7761 45.7761 24 45.5 24H43.5C43.2239 24 43 23.7761 43 23.5C43 23.2239 43.2239 23 43.5 23H45.5C45.7761 23 46 23.2239 46 23.5Z",
    fill: "#2C666E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 26.5C46 26.7761 45.7761 27 45.5 27H43.5C43.2239 27 43 26.7761 43 26.5C43 26.2239 43.2239 26 43.5 26H45.5C45.7761 26 46 26.2239 46 26.5Z",
    fill: "#2C666E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 29.5C46 29.7761 45.7761 30 45.5 30H43.5C43.2239 30 43 29.7761 43 29.5C43 29.2239 43.2239 29 43.5 29H45.5C45.7761 29 46 29.2239 46 29.5Z",
    fill: "#2C666E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 32.5C46 32.7761 45.7761 33 45.5 33H43.5C43.2239 33 43 32.7761 43 32.5C43 32.2239 43.2239 32 43.5 32H45.5C45.7761 32 46 32.2239 46 32.5Z",
    fill: "#2C666E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 35.5C46 35.7761 45.7761 36 45.5 36H43.5C43.2239 36 43 35.7761 43 35.5C43 35.2239 43.2239 35 43.5 35H45.5C45.7761 35 46 35.2239 46 35.5Z",
    fill: "#2C666E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.5C13 17.7761 12.7761 18 12.5 18H10.5C10.2239 18 10 17.7761 10 17.5C10 17.2239 10.2239 17 10.5 17H12.5C12.7761 17 13 17.2239 13 17.5Z",
    fill: "#2C666E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20.5C13 20.7761 12.7761 21 12.5 21H10.5C10.2239 21 10 20.7761 10 20.5C10 20.2239 10.2239 20 10.5 20H12.5C12.7761 20 13 20.2239 13 20.5Z",
    fill: "#2C666E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23.5C13 23.7761 12.7761 24 12.5 24H10.5C10.2239 24 10 23.7761 10 23.5C10 23.2239 10.2239 23 10.5 23H12.5C12.7761 23 13 23.2239 13 23.5Z",
    fill: "#2C666E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 26.5C13 26.7761 12.7761 27 12.5 27H10.5C10.2239 27 10 26.7761 10 26.5C10 26.2239 10.2239 26 10.5 26H12.5C12.7761 26 13 26.2239 13 26.5Z",
    fill: "#2C666E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 29.5C13 29.7761 12.7761 30 12.5 30H10.5C10.2239 30 10 29.7761 10 29.5C10 29.2239 10.2239 29 10.5 29H12.5C12.7761 29 13 29.2239 13 29.5Z",
    fill: "#2C666E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 32.5C13 32.7761 12.7761 33 12.5 33H10.5C10.2239 33 10 32.7761 10 32.5C10 32.2239 10.2239 32 10.5 32H12.5C12.7761 32 13 32.2239 13 32.5Z",
    fill: "#2C666E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 35.5C13 35.7761 12.7761 36 12.5 36H10.5C10.2239 36 10 35.7761 10 35.5C10 35.2239 10.2239 35 10.5 35H12.5C12.7761 35 13 35.2239 13 35.5Z",
    fill: "#2C666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUx);
export default __webpack_public_path__ + "static/media/ux.4bad1ab5fb315705895260aa40468fdb.svg";
export { ForwardRef as ReactComponent };